export default __webpack_public_path__ + "static/media/logo1.9738d509.png";